darkmode.forEach((e) => {
    e.addEventListener("click", (e) => {
        if (e.currentTarget.checked) {
            body.classList.add("mm-darkmode");
            sessionStorage["darkmode"] = true;
        } else if (!body.classList.contains("mm-darkmode")) {
        } else {
            body.classList.remove("mm-darkmode");
            sessionStorage["darkmode"] = false;
        }
        updateOtherButtonDarkMode(e.currentTarget.checked);
    });
});

function updateOtherButtonDarkMode(checked) {
    darkmode.forEach((elem) => {
        elem.checked = checked;
    });
}

// MOBILE MENU
function mmMobileMenu() {
    const mobileMenu = document.querySelector(".mm-mobile-menu-wrapper");
    const headerSection = document.querySelector(".mm-header-section");
    const headerHeight = headerSection.offsetHeight;
    
    mobileMenu.classList.toggle("mm-menu-open");
    menu.classList.toggle("mm-header-open");
    if (mobileMenu.classList.contains("mm-menu-open")) {
        document.querySelector("html").classList.add("stop-scrolling");
        mmRemoveHeaderLight();

        // Position the menu right below the sticky header only
        mobileMenu.style.top = `${headerHeight}px`;
    } else {
        document.querySelector("html").classList.remove("stop-scrolling");
    }
}

function mmMobileMenuAccount() {
    const mobileMenu = document.querySelector(".mm-second-menu-items-account-mobile");
    const headerSection = document.querySelector(".mm-header-section");
    const headerHeight = headerSection.offsetHeight;
    
    mobileMenu.classList.toggle("mm-menu-open");
    menu.classList.toggle("mm-header-open");
    if (mobileMenu.classList.contains("mm-menu-open")) {
        document.querySelector("html").classList.add("stop-scrolling");
        mmRemoveHeaderLight();
        
        // Position the menu right below the sticky header only
        mobileMenu.style.top = `${headerHeight}px`;
    } else {
        document.querySelector("html").classList.remove("stop-scrolling");
    }
}

function mmMobileMenuDropdown(elem, elem2) {
    var elemSelector = document.querySelector(elem);
    var elemSelector2 = document.querySelector(elem2);

    elemSelector.classList.toggle("open");
    elemSelector2.classList.toggle("open");
    document.querySelector("html").classList.toggle("stop-scrolling");
}

function showInfoDarkButton(elemToShowClass) {
    let elemToShow = document.querySelectorAll(elemToShowClass);
    elemToShow.forEach((element) => {
        let darkButton = element.nextElementSibling;
        darkButton.classList.toggle("hidden");
    });
}
$('body').on('mouseenter mouseleave', '.mm-delivery-info', function (e) {
    $(this).next().toggleClass('hidden');
});

// Target blank External (Calendly) menu link
(function () {
    var links = document.links;
    for (let i = 0, linksLength = links.length; i < linksLength; i++) {
        if (links[i].hostname !== window.location.hostname) {
            links[i].target = "_blank";
            links[i].rel = "noreferrer noopener";
        }
    }
})();
